export default class StyleObject {

  private obj: { [index: string]: string | number } = {}

  constructor(el: HTMLElement) {
    const styleString = el.getAttribute('style')

    if (styleString === null) {
      return
    }

    styleString
      .split(';')
      .map((str1) => {
        return str1.split(':')
          .map((str2) => str2.trim())
      })
      .forEach((arr) => {
        const key = arr[0]
        const value = arr[1]

        if (key.length > 0) {
          this.obj[key] = value
        }
      })
  }

  public add(key: string, value: string | number) {
    this.obj[key] = value
  }

  public remove(key: string) {
    delete this.obj[key]
  }

  public get(key: string) {
    if (this.obj.hasOwnProperty(key)) {
      return this.obj[key]
    }

    return null
  }

  public toString() {
    let str = ''

    for (const key in this.obj) {
      if (this.obj.hasOwnProperty(key)) {
        str += `${key}: ${this.obj[key]}; `
      }
    }

    return str
  }

  public getWidth() {
    if (this.obj.hasOwnProperty('width')) {
      return Number.parseInt(this.obj.width as string, 10)
    }

    return null
  }

  public getHeight() {
    if (this.obj.hasOwnProperty('height')) {
      return Number.parseInt(this.obj.height as string, 10)
    }

    return null
  }
}
